module.exports = __webpack_public_path__ + "img/avatar5.26fb3132.png";